import { BaseContext } from '../../utils/basecontext';
import { HttpClient } from '../../utils/httpclient/httpclient';
import { Logger, LogManager } from '../../utils/logger/logger';
import { APIRequest } from '../api/apiRequest';
import { APIResponse } from '../api/apiresponse';
import { ListLikeToneAPI } from '../api/listlikedtone/listliketoneapi';
import { ListLikeToneRequest } from '../api/listlikedtone/listliketonerequest';
import { ListLikeToneResponse } from '../api/listlikedtone/listliketoneresponse';
import { APIProcessor } from '../processor/apiProcessor';
import { ListLikeToneAPIProcessorImpl } from '../processor/listliketoneapiprocessor';
import { ProcessorFactoryImpl } from './processorfactory';

export class ListLikeToneProcessorFactory  extends ProcessorFactoryImpl<APIRequest, APIResponse>
{
    private logger: Logger = LogManager.getLogger(ListLikeToneProcessorFactory.name);

    constructor(applicationContext: BaseContext, httpClient: HttpClient)
    {
        super(applicationContext, httpClient);
    }

    getListLikeToneDetails():APIProcessor<ListLikeToneRequest, ListLikeToneResponse>
    {
        this.logger.log("getListLikeToneDetails() invoked");
        return new ListLikeToneAPIProcessorImpl(this.getContext(), new ListLikeToneAPI(this.getHttpClient(), this.getContext()));
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processorfactory/listliketoneprocessorfactory.tsx